import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConfirmationOfApplication } from '@/features/ui';
import { DeliveryAddressPreview } from '@/features/ui/Steps/DeliveryAddress/DeliveryAddress';

import { ConditionView, StepControlPanel } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { ExtractRedeliveryPersonalDataPreview } from './ExtractRedeliveryPersonalData';

export interface DataPreviewProps {
  submitForm?: (formData: any) => Promise<void>;
  shouldBeAbleToUpdateProfile: boolean;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({
  next,
  prev,
  submitForm,
  shouldBeAbleToUpdateProfile,
}) => {
  const { getValues, watch } = useFormContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const confirmEnteredDataCorrect = watch('confirmEnteredDataCorrect');

  const handleNextStep = (): void => {
    setIsLoading(true);

    submitForm?.(getValues())
      .then(() => next())
      .catch(console.error)
      .finally(() => setIsLoading(false));
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних" className="form-block__data-preview">
        <ExtractRedeliveryPersonalDataPreview />
        <DeliveryAddressPreview />
      </FormBlock>
      <ConfirmationOfApplication
        updateProfileLabelElement="Я хочу додати/оновити свій профіль згідно даних, які введені в цьому запиті"
        shouldBeAbleToUpdateProfile={shouldBeAbleToUpdateProfile}
      />
      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
